import { useMutation } from "@apollo/client";
import { UpdateContactDocument } from "@/__generated__/graphql";

export const useUpdateContactMutation = () => {
  return useMutation(UpdateContactDocument);
};
